import { useState, useEffect } from 'react';

const useNotification = () => {
  const [notification, setNotification] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect if user is on mobile device
  useEffect(() => {
    const checkIsMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['android', 'iphone', 'ipad', 'mobile', 'tablet'];
      const isMobileUserAgent = mobileKeywords.some(keyword => userAgent.includes(keyword));
      const isMobileScreen = window.innerWidth <= 768;
      setIsMobile(isMobileUserAgent || isMobileScreen);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const showNotification = (message, type = 'success') => {
    setNotification({ 
      message, 
      type,
      timestamp: Date.now(),
      isMobile
    });
    setTimeout(() => setNotification(null), type === 'error' ? 8000 : 5000);
  };

  const showDetailedNotification = (title, details, type = 'success') => {
    setNotification({
      title,
      message: details,
      type,
      isDetailed: true,
      timestamp: Date.now(),
      isMobile
    });
    
    setTimeout(() => setNotification(null), type === 'error' ? 12000 : 8000);
  };

  // New function for import/export operations - Big notification with progress
  const showImportExportNotification = (title, message, type = 'info', progress = null) => {
    setNotification({
      title,
      message,
      type,
      isImportExport: true,
      isDetailed: true,
      progress,
      timestamp: Date.now(),
      isMobile
    });
    
    // Longer timeout for import/export operations
    if (type !== 'progress') {
      setTimeout(() => setNotification(null), type === 'error' ? 15000 : 10000);
    }
  };

  // New function for single proverb operations - Bottom notification
  const showProverbNotification = (message, type = 'success') => {
    setNotification({
      message,
      type,
      isProverbAction: true,
      position: isMobile ? 'top' : 'bottom',
      timestamp: Date.now(),
      isMobile
    });
    
    setTimeout(() => setNotification(null), type === 'error' ? 6000 : 3000);
  };

  const hideNotification = () => {
    setNotification(null);
  };

  return {
    notification,
    showNotification,
    showDetailedNotification,
    showImportExportNotification,
    showProverbNotification,
    hideNotification,
    isMobile
  };
};

export default useNotification;
